import { Link } from "@inertiajs/react";
import { ArrowLeft, MessageSquareText } from "lucide-react";
import { AdminLayout } from "@/layouts/AdminLayout";
import { ChatbotPreviewPanel, type ChatbotPreviewData } from "@/components/ChatbotPreviewPanel";
import { buttonVariants } from "@/components/ui/button";

interface Props extends ChatbotPreviewData {
  organization: {
    id: number;
    name: string;
    slug: string;
  };
  business: {
    id: number;
    name: string;
  } | null;
  flash?: {
    notice?: string;
    alert?: string;
  };
}

export default function ChatbotPlayground({
  organization,
  business,
  messages,
  limits,
  flash = {},
}: Props) {
  const previewPath = `/admin/organizations/${organization.id}/chatbot_playground`;

  return (
    <AdminLayout>
      <div className="mx-auto flex h-full max-w-5xl flex-col gap-5">
        <div className="space-y-2">
          <Link
            href={`/admin/organizations/${organization.id}`}
            className={buttonVariants({ variant: "ghost", size: "sm" })}
          >
            <ArrowLeft className="mr-1 h-4 w-4" />
            Volver a {organization.name}
          </Link>
          <div>
            <h1 className="flex items-center gap-2 text-2xl font-bold text-foreground">
              <MessageSquareText className="h-6 w-6" />
              Probar chatbot
            </h1>
            <p className="text-sm text-muted-foreground">
              Respuestas como cliente para {business?.name || organization.name}
            </p>
          </div>
        </div>

        {flash.notice && (
          <div className="rounded-lg border border-green-500/40 bg-green-500/10 p-3 text-sm text-foreground" role="status">
            {flash.notice}
          </div>
        )}
        {flash.alert && (
          <div className="rounded-lg border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive" role="alert">
            {flash.alert}
          </div>
        )}

        <ChatbotPreviewPanel
          business={business}
          messages={messages}
          limits={limits}
          messagePath={`${previewPath}/messages`}
          resetPath={previewPath}
          title={organization.name}
        />
      </div>
    </AdminLayout>
  );
}
